"use client";

import { useSyncExternalStore } from "react";
import { isInternalVisitor } from "@/lib/internal-visitor";

// Same SSR/hydration pattern as CookieBanner.tsx: server snapshot is
// always false (no flicker on first paint), then react switches to the
// real client snapshot right after mount without a useEffect+setState
// round trip.
const subscribe = () => () => {};

export function InternalVisitorBadge() {
  const isInternal = useSyncExternalStore(
    subscribe,
    isInternalVisitor,
    () => false,
  );

  if (!isInternal) return null;

  return (
    <div
      role="status"
      className="fixed bottom-4 right-4 z-50 flex items-center gap-2 rounded-full px-3 py-1.5 text-xs font-semibold shadow-lg"
      style={{
        backgroundColor: "var(--color-primary-dark)",
        color: "var(--color-gold-light)",
      }}
    >
      분석 제외됨
      {/* Plain <a>, not next/link: the flag is applied/cleared by
          internal-visitor.ts's module-scope code, which runs once per full
          page load. A client-side transition would change the URL without
          re-running that code, so turning the flag off needs a real
          navigation. */}
      <a
        href="?internal=0"
        className="underline underline-offset-2"
        style={{ color: "var(--color-cream)" }}
      >
        해제
      </a>
    </div>
  );
}
